module.exports = __webpack_public_path__ + "static/img/bg-es.a1689b43.webp";